class FlipCountdown extends HTMLElement {
  constructor() {
    super();
    this.initialized = false;
    this.timer = null;
    this.numbers = this.querySelectorAll('.countdown-number');
    
    // Get duration from data attributes
    this.days = parseInt(this.getAttribute('data-days')) || 0;
    this.hours = parseInt(this.getAttribute('data-hours')) || 0;
    this.minutes = parseInt(this.getAttribute('data-minutes')) || 0;
    
    this.initializeCountdown();
  }

  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.timer = null;
    this.numbers = this.querySelectorAll('.countdown-number');
    
    // Get duration from data attributes
    this.days = parseInt(this.getAttribute('data-days')) || 0;
    this.hours = parseInt(this.getAttribute('data-hours')) || 0;
    this.minutes = parseInt(this.getAttribute('data-minutes')) || 0;
    
    this.initializeCountdown();
  }

  initializeCountdown() {
    // Calculate end time based on duration
    const now = new Date();
    const totalMinutes = (this.days * 24 * 60) + (this.hours * 60) + this.minutes;
    const endTime = new Date(now.getTime() + totalMinutes * 60 * 1000);
    
    this.updateDisplay(endTime - now);
    
    this.timer = setInterval(() => {
      const timeLeft = endTime - new Date();
      
      if (timeLeft <= 0) {
        clearInterval(this.timer);
        this.updateDisplay(0);
      } else {
        this.updateDisplay(timeLeft);
      }
    }, 1000);
  }

  updateDisplay(timeLeft) {
    const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

    const values = [days, hours, minutes, seconds];
    this.numbers.forEach((number, index) => {
      number.textContent = String(values[index]).padStart(2, '0');
    });
  }

  disconnectedCallback() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
}

customElements.define('flip-countdown', FlipCountdown); 